import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatDate, getActivityIcon, getActivityLabel } from './useContributorDashboard';

const ActivityTab = ({ points }) => {
  return (
    <Card className="bg-slate-800/50 border-slate-700">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg text-white">Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {points?.activities?.length > 0 ? (
          <div className="space-y-2 max-h-80 overflow-y-auto">
            {points.activities.map((activity, idx) => (
              <div 
                key={idx}
                className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">{getActivityIcon(activity.activity_type)}</span>
                  <div>
                    <p className="text-white font-medium">{getActivityLabel(activity.activity_type)}</p>
                    <p className="text-xs text-gray-400">{formatDate(activity.created_at)}</p>
                    {activity.description && (
                      <p className="text-xs text-gray-500">{activity.description}</p>
                    )}
                  </div>
                </div>
                <Badge className="bg-cyan-600">+{activity.points} pts</Badge>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-500 py-8">No activity this month yet</p>
        )}
      </CardContent>
    </Card>
  );
};

export default ActivityTab;
